// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import type { CycleTimeReportFilter } from '@/report/api/types';
import {
  getOutboundShipmentCycleTimeReport,
  serializeOutboundShipmentCycleTimeReportFilter,
} from '@/shipment/api/get-outbound-shipment-cycle-time-report';
import { outboundShipmentCycleTimeReportQueryKey } from '@/shipment/hooks/use-shipments';
import { ONE_MINUTE_MS } from '@/utilities/time-constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

interface UseOutboundShipmentCycleTimeReportOptions {
  filter?: CycleTimeReportFilter;
}

export function useOutboundShipmentCycleTimeReport(
  options: UseOutboundShipmentCycleTimeReportOptions = {}
) {
  const filterString = serializeOutboundShipmentCycleTimeReportFilter(
    options.filter
  );
  const { data, ...query } = useQuery({
    queryKey: outboundShipmentCycleTimeReportQueryKey(filterString),
    queryFn: () => getOutboundShipmentCycleTimeReport(options.filter),
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    staleTime: ONE_MINUTE_MS,
    throwOnError: true,
  });

  return { report: data?.data ?? null, ...query };
}
